import e from"react";const t=(t,r)=>{const n={dangerouslySetInnerHTML:{__html:t}};return e.createElement(r,n)};export{t as default};
